 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHTPAGE from '@/components/copyright-page'
 import CONTENTS from '@/components/contents'
 import CHAPTER01 from '@/components/chapter01'
 import CHAPTER03 from '@/components/chapter03'
 import CHAPTER06 from '@/components/chapter06'
 import CHAPTER08 from '@/components/chapter08'
 import CHAPTER09 from '@/components/chapter09'
 import CHAPTER10 from '@/components/chapter10'
 import CHAPTER11 from '@/components/chapter11'
 import CHAPTER12 from '@/components/chapter12'
 import CHAPTER13 from '@/components/chapter13'
 import CHAPTER14 from '@/components/chapter14'
 import CHAPTER15 from '@/components/chapter15'
 import CHAPTER16 from '@/components/chapter16'
 import CHAPTER17 from '@/components/chapter17'
 import CHAPTER18 from '@/components/chapter18'
 import CHAPTER19 from '@/components/chapter19'
 import CHAPTER20 from '@/components/chapter20'
 import CHAPTER21 from '@/components/chapter21'
 import CHAPTER22 from '@/components/chapter22'
 import CHAPTER23 from '@/components/chapter23'
 import CHAPTER24 from '@/components/chapter24'
 import CHAPTER25 from '@/components/chapter25'
 import CHAPTER26 from '@/components/chapter26'
 import CHAPTER27 from '@/components/chapter27'
 import CHAPTER28 from '@/components/chapter28'
 import CHAPTER29 from '@/components/chapter29'
 import CHAPTER30 from '@/components/chapter30'
 import CHAPTER31 from '@/components/chapter31'
 import CHAPTER32 from '@/components/chapter32'
 import CHAPTER33 from '@/components/chapter33'
 import CHAPTER34 from '@/components/chapter34'
 import CHAPTER35 from '@/components/chapter35'
 import CHAPTER36 from '@/components/chapter36'
 import CHAPTER37 from '@/components/chapter37'
 import CHAPTER38 from '@/components/chapter38'
 import CHAPTER39 from '@/components/chapter39'
 import CHAPTER40 from '@/components/chapter40'
 import CHAPTER41 from '@/components/chapter41'
 import CHAPTER42 from '@/components/chapter42'
 import CHAPTER43 from '@/components/chapter43'
 import CHAPTER44 from '@/components/chapter44'
 import CHAPTER45 from '@/components/chapter45'
 import CHAPTER46 from '@/components/chapter46'
 import CHAPTER47 from '@/components/chapter47'
 import CHAPTER48 from '@/components/chapter48'
 import CHAPTER49 from '@/components/chapter49'
 import CHAPTER50 from '@/components/chapter50'
 import CHAPTER51 from '@/components/chapter51'
 import CHAPTER52 from '@/components/chapter52'
 import CHAPTER53 from '@/components/chapter53'
 import CHAPTER54 from '@/components/chapter54'
 import CHAPTER55 from '@/components/chapter55'
 import CHAPTER56 from '@/components/chapter56'
 import CHAPTER57 from '@/components/chapter57'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/chapter01",
 			"name" : "chapter01",
 			"component" : CHAPTER01
 		},
 		{
 			"path" : "/chapter03",
 			"name" : "chapter03",
 			"component" : CHAPTER03
 		},
 		{
 			"path" : "/chapter06",
 			"name" : "chapter06",
 			"component" : CHAPTER06
 		},
 		{
 			"path" : "/chapter08",
 			"name" : "chapter08",
 			"component" : CHAPTER08
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js